import {
  useAddToCollection,
  useCollectionQuantities,
  useUpdateCollectionByCard,
  useRemoveFromCollectionByCard,
} from '@/hooks/collections/useCollectionCrud'
import { useUserQuantities } from '@/hooks/collections/useUserQuantities'
import { useUserFilters, useHideCard, useUnhideCard } from '@/hooks/filters/useUserFilters'
import { useBuylistQuantities, useAddToBuylist, useRemoveFromBuylist } from '@/hooks/lists/useBuylist'
import { useSelllistQuantities, useAddToSelllist, useRemoveFromSelllist } from '@/hooks/lists/useSelllist'

export function useCardActions() {
  // Fetch all quantities in one request; seeds individual caches
  useUserQuantities()

  const { data: quantities = {} } = useCollectionQuantities()
  const addToCollection = useAddToCollection()
  const updateCollectionByCard = useUpdateCollectionByCard()
  const removeFromCollectionByCard = useRemoveFromCollectionByCard()

  const { data: userFilters } = useUserFilters()
  const hideCard = useHideCard()
  const unhideCard = useUnhideCard()

  const { data: buylistQuantities = {} } = useBuylistQuantities()
  const addToBuylist = useAddToBuylist()
  const removeFromBuylist = useRemoveFromBuylist()

  const { data: selllistQuantities = {} } = useSelllistQuantities()
  const addToSelllist = useAddToSelllist()
  const removeFromSelllist = useRemoveFromSelllist()

  return {
    quantities,
    buylistQuantities,
    selllistQuantities,
    userFilters,
    addToCollection,
    updateCollectionByCard,
    removeFromCollectionByCard,
    hideCard,
    unhideCard,
    addToBuylist,
    removeFromBuylist,
    addToSelllist,
    removeFromSelllist,
  }
}
